import React, { useState } from "react";

const CustomFilterInput = ({
  value,
  onChange,
  placeholder,
  inputType,
  customMaxW,
}) => {
  const [localValue, setLocalValue] = useState("");
  const handleChange = (e) => {
    setLocalValue(e.target.value);
    onChange(e);
  };
  return (
    <input
      className={` focus:ring-transparent border-1px border-accent-green rounded-full py-[8px] px-4 text-dark-green outline-none bg-white ${
        customMaxW ? customMaxW : ""
      } w-full font-poppins`}
      value={value}
      onChange={handleChange}
      placeholder={`${placeholder ? placeholder : "Buscar"}`}
      type={inputType}
    ></input>
  );
};

export default CustomFilterInput;
